import { Pagination } from "antd";

import { BasePaginationProps } from "@/components_v2/Pagination/types";

const BasePagination = ({ ...props }: BasePaginationProps) => {
  return <Pagination {...props} />;
};

export default BasePagination;
